export default {"src":"/_next/static/media/down-accordion.cc6c07fa.svg","height":30,"width":12};